import { clsx } from 'clsx';
import { PACT_BOONS, getPactBoon } from '@character-creator/data';

interface PactBoonSelectorProps {
  selectedPactBoonId: string | null;
  onSelect: (pactBoonId: string | null) => void;
  compact?: boolean;
}

export function PactBoonSelector({
  selectedPactBoonId,
  onSelect,
  compact = false,
}: PactBoonSelectorProps) {
  const selectedPactBoon = selectedPactBoonId ? getPactBoon(selectedPactBoonId) : null;

  // Compact view - shows selected pact boon with change option
  if (compact && selectedPactBoon) {
    return (
      <div className="text-xs text-success flex items-center gap-1">
        <span>{selectedPactBoon.name}</span>
        <button
          type="button"
          onClick={() => onSelect(null)}
          className="ml-2 text-text-muted hover:text-error transition-colors"
        >
          (change)
        </button>
      </div>
    );
  }

  return (
    <div>
      <h5 className="text-sm font-medium text-text-primary mb-2">
        Pact Boon
        {!selectedPactBoonId && (
          <span className="text-warning ml-2 text-xs">(Required)</span>
        )}
      </h5>
      <p className="text-xs text-text-muted mb-3">
        At 3rd level, your otherworldly patron bestows a gift upon you for your loyal service.
      </p>
      <div className="grid grid-cols-1 gap-2">
        {PACT_BOONS.map((pactBoon) => (
          <button
            key={pactBoon.id}
            type="button"
            onClick={() => onSelect(pactBoon.id)}
            className={clsx(
              'w-full text-left p-3 rounded-lg border transition-all duration-200',
              selectedPactBoonId === pactBoon.id
                ? 'bg-accent-gold/10 border-accent-gold'
                : 'bg-background-secondary border-background-elevated hover:border-text-muted'
            )}
          >
            <div className="font-medium text-text-primary text-sm">{pactBoon.name}</div>
            <p className="text-xs text-text-secondary mt-1">{pactBoon.description}</p>
          </button>
        ))}
      </div>
    </div>
  );
}
